export const DATA_SOURCE_TYPE_BUSINESS_UNITS = "BUSINESS_UNITS";
export const DATA_SOURCE_TYPE_AD_ACCOUNTS = "AD_ACCOUNTS";

export const getDataByDataSourceType = (t) => ({
    [DATA_SOURCE_TYPE_BUSINESS_UNITS]: t('data_source_type.business_units'),
    [DATA_SOURCE_TYPE_AD_ACCOUNTS]: t('data_source_type.ad_accounts'),
});
